import React from "react"
import styled, { createGlobalStyle, keyframes } from "styled-components/macro"
import colors from "./scripts/colors"
import "@fontsource/noto-sans-jp"
import "@fontsource/noto-sans-jp/400.css"
import "@fontsource/raleway"
import "@fontsource/raleway/400.css"
import TitleArrow from "./images/iconmonstr-arrow-24---outline.svg"
import { camelCase } from "camel-case"

type PropTypes = {
  display?: string
}

const spinnerAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`

const GlobalStyles = createGlobalStyle`

header, nav, main, footer, article, section, aside {
   display:block;
}

/* STICKY FOOTER */
html, body, #___gatsby {
    margin: 0;
    /* overflow-x: hidden; */
    scroll-behavior: smooth;
    @supports (display: grid) {
      height: 100%;
    }
  }
  #gatsby-focus-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  #StickyFooter--body {
    flex: 1 0 auto;
  }
  #SiteFooter {
    flex-shrink: 0;
  }

  body {
    font-family: "Raleway", sans-serif
  }

  h1, h2, h3, h4 {
    font-family: "Noto Sans JP", sans-serif;
    color: ${colors("blue")}
  }

  a {
    color: ${colors("green", "lnk")};
    text-decoration: none;
    font-weight: 400;
    transition: all 0.25s;
    &:hover {
    color: ${colors("green", "lnkhlt")};
    }
  }

  svg {
    fill: currentColor
  }
  form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    @media screen and (min-width: 1024px) {
      width: 870px;
    }
    [type="submit"],
    [type="reset"],
    #ContactForm-sendingIndicator,
    #ContactForm-sentIndicator {
      margin-left: 0;
      padding-left: 0;
    }
    #ContactForm-sendingIndicator,
    #ContactForm-sentIndicator {
      cursor: default;
      .Button-content {
        background-color: ${colors("blue", "xdk")};
      }
      .Button-icon {
        background-color: ${colors("blue")};
      }
    }
    #ContactForm-sendingIndicator {
        svg {
          animation: 1.5s ${spinnerAnimation} linear infinite;
        }
      }
    }
    #ContactForm-resetButton {
      margin-left: 20px
    }
  }

  #lightboxBackdrop {
    button {
      transition: all 0.25s;
      color: ${colors("green", "lnk")};
      &:hover {
        color: ${colors("green", "lnkhlt")};
      }
      &[class*="close"] {
      color: ${colors("red")};
        &:hover {
          color: ${colors("red", "hlt")};
        }
      }
    }
  }
`

export const PageMargin = styled.div`
  width: 95%;
  margin: 0 auto;
  @media screen and (min-width: 1024px) {
    width: 900px;
  }
  @media screen and (min-width: 1500px) {
    width: 1200px;
    display: ${(props: PropTypes) => props.display || "block"};
  }
`

const SectionHeaderStyles = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid ${colors("grey", "xlt")};
  /* border-bottom: none; */
  padding: 20px;
  padding-right: calc(20px - 0.18em);
  padding-bottom: 0;
  position: relative;
  z-index: 100;
  margin-bottom: 30px;
  h2 {
    margin: 0 0 13px;
    line-height: 1em;
    font-size: 25px;
    font-weight: 300;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${colors("blue")};
  }
  svg {
    color: ${colors("purple")};
    width: 25px;
    margin-bottom: -10px;
  }
`

export const SectionHeader = ({ children }) => (
  <>
    <SectionHeaderStyles>
      <h2>{children}</h2>
      <TitleArrow id={`SectionHeader-icon--${camelCase(children)}`} />
    </SectionHeaderStyles>
  </>
)

export default GlobalStyles
